/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    PROFILE VIDEO AUTOPLAY
\*------------------------------------*/
class YoutubeProfileVideo {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;
        self.vid = self.elem.dataset.videoid;
    }

    init() {
        let self = this;

        self.elem.addEventListener('click', function() {
            let iframe = document.querySelector('iframe#yvid-'+ self.vid);

            $('#video-tab').tab('show');
            document.getElementById('stallion-gallery').scrollIntoView({ block: 'start',  behavior: 'smooth' });
            $(iframe)[0].src += "?autoplay=1";
        });
    }
}

export default YoutubeProfileVideo;
